import * as React from "react";
import styled, { css } from "styled-components";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Job from "data-lake/components/Job";
import { Row, Col } from "components/bootstrap";
import useDataLakeJobs from "data-lake/hooks/useDataLakeJobs";
const StyledH2 = styled.h2(
  ({ theme }) => css`
    margin-bottom: ${theme.spacings.xs};
  `
);
const DataLakeJobs = ({ streamId = null }) => {
  const { t } = useTranslation("enterprise_data_lake");
  const {
    dataLakeData: { inProgressCount, jobs },
    isLoadingDataLake,
    isError,
    onCancelDataLakeJob,
    onAcknowledgeDataLakeJob
  } = useDataLakeJobs(streamId);
  const params = useParams();
  const { archiveId } = params;
  if (isLoadingDataLake || isError || inProgressCount === 0 || !jobs) {
    return null;
  }
  const archivingJobs = jobs.filter((j) => {
    if (!archiveId) {
      return true;
    }
    return j.archive.join(",").includes(archiveId);
  }).map((job, index) => /* @__PURE__ */ React.createElement(
    Job,
    {
      key: job.id,
      index,
      job,
      onCancel: onCancelDataLakeJob,
      onAcknowledge: onAcknowledgeDataLakeJob
    }
  ));
  return /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(StyledH2, null, t("jobs.title")), archivingJobs));
};
export default DataLakeJobs;
